module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "nav"
  }, [_c('mt-button', {
    attrs: {
      "size": "small"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.active = 'tab-container1'
      }
    }
  }, [_vm._v("tab 1")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "small"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.active = 'tab-container2'
      }
    }
  }, [_vm._v("tab 2")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "small"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.active = 'tab-container3'
      }
    }
  }, [_vm._v("tab 3")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-tab-container"
  }, [_c('mt-tab-container', {
    staticClass: "page-tabbar-tab-container",
    attrs: {
      "swipeable": ""
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('mt-tab-container-item', {
    attrs: {
      "id": "tab-container1"
    }
  }, _vm._l((10), function(n) {
    return _c('mt-cell', {
      attrs: {
        "title": "tab-container 1"
      }
    })
  })), _vm._v(" "), _c('mt-tab-container-item', {
    attrs: {
      "id": "tab-container2"
    }
  }, _vm._l((5), function(n) {
    return _c('mt-cell', {
      attrs: {
        "title": "tab-container 2"
      }
    })
  })), _vm._v(" "), _c('mt-tab-container-item', {
    attrs: {
      "id": "tab-container3"
    }
  }, _vm._l((7), function(n) {
    return _c('mt-cell', {
      attrs: {
        "title": "tab-container 3"
      }
    })
  }))], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4832004b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/pages/tab-container.vue
// module id = 291
// module chunks = 0